import { render } from "./OnboardingItem.vue?vue&type=template&id=34293083"
import script from "./OnboardingItem.vue?vue&type=script&lang=js"
export * from "./OnboardingItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__